import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Section } from 'foundations-components/transitional/components/Section';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SepaModalTerms = () => {
  return /*#__PURE__*/_jsxs(DialogBody, {
    "data-test-id": "sepa-authorization-modal-terms",
    children: [/*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        as: "p",
        children: /*#__PURE__*/_jsx("span", {
          "data-test-id": "sepa-auth-modal-terms-one",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.paymentElementAuthModal.sepaPaymentAuthDescription1"
          })
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        as: "p",
        children: /*#__PURE__*/_jsx("span", {
          "data-test-id": "sepa-auth-modal-terms-two",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.paymentElementAuthModal.sepaPaymentAuthDescription2"
          })
        })
      })
    })]
  });
};
export default SepaModalTerms;